import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { entite } from 'src/app/models/entite';
import { collabService } from 'src/app/services/collab/collabService.service';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { ProfilDto } from 'src/app/models/ProfilDto';
import { KeycloakService } from 'keycloak-angular';
import { collabDto } from 'src/app/models/collabDto';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToggleSwitchModule } from 'primeng/toggleswitch';


@Component({
  selector: 'app-form-vendeur-modif',
  templateUrl: './form-vendeur-modif.component.html',
  imports: [CommonModule,FormsModule,ToastModule,ButtonModule,ReactiveFormsModule,InputTextModule,SelectButtonModule,SelectModule,ButtonModule,ProgressBarModule,ToggleSwitchModule],
  styleUrls: ['./form-vendeur-modif.component.scss']
})
export class FormVendeurModifComponent implements OnInit {

  selectedEntite!: entite;
  libelleselected: string = '';
  selectedProfilolibelle: string = '';
  statutVendeur: boolean = true;
  prenomSelected: any;
  emailSelected: any;
  telephoneSelected: any;
  numCollabSelected: any;
  vendeuraAjoute: any = {

    nom: '',
    prenom: '',
    telgsm: '',
    actif: '',
    web: '',
    mail: '',
    numEntite: '',
    user: '',
    profil: '',
    titre: '',
    numCollab: '',
    dc: '',
    dm: ''

  };
  selectedProfilo!: ProfilDto;
  titreselected: any;
  profilos: ProfilDto[] = [];
  @Output() closeDialog = new EventEmitter<void>();

  //disabled: boolean=true;
  constructor(private router: Router, private collab: collabService, private entiteservice: EntitebackService, public share: shareOpeSevices,
    private fb: FormBuilder, private collabservice: collabService, public messageService: MessageService, private readonly keycloakService: KeycloakService) { }
  entites!: entite[]
  ngOnInit(): void {
    this.share.sendVendeur$.subscribe((data: collabDto) => {
      if (data != null) {
        this.vendeuraAjoute = data;
        //this.statutVendeur = this.vendeuraAjoute.actif == '1' ? true : false ;
        this.emailSelected = this.vendeuraAjoute.email;
        this.libelleselected = this.vendeuraAjoute.nom;
        this.prenomSelected = this.vendeuraAjoute.prenom;
        this.telephoneSelected = this.vendeuraAjoute.telgsm.replace(/\s/g, "");
        this.numCollabSelected = this.vendeuraAjoute.numCollab;

        this.entiteservice.getAllEntites().subscribe((entities) => {
          this.entites = entities;
          this.entiteservice.getEntitebyId(parseInt(this.vendeuraAjoute?.numEntite)).subscribe((resultat: entite) => {
            if (this.entites && this.entites.length > 0) {
              this.entites[0] = resultat;
              this.selectedEntite = this.entites[0];
            } else {
              this.entites = [resultat];
              this.selectedEntite = resultat;
            }
            this.selectedEntite = resultat;
          });
        });

        this.collabservice.getProfils().subscribe({
          next: (dd) => {
            this.profilos = (dd);
          },
          complete: () => {
            this.collab.getProfilBya1Code(parseInt(this.vendeuraAjoute?.profil)).subscribe((profil: ProfilDto) => {

              this.selectedProfilo = profil;
              this.selectedProfilolibelle = profil.libelle;
            });
          }
        });
      }
    });
  }

  entiteForm = this.fb.group({
    nom: ['', [Validators.required, Validators.pattern('^[a-zA-ZÀ-ÿ\\s\\-]{3,}$')]],
    prenom: ['', [Validators.required, Validators.pattern('^[a-zA-ZÀ-ÿ\\s\\-]{3,}$')]],
    type: [""],
    adressmail: { value: '', disabled: true }, //['', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}')]]
    actif: true,
    telephone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    entite: ['', Validators.required],
    titre: [''],
    profil: { value: '', disabled: true }
  });


  update() {
    this.share.showprogressbar = true;
    this.vendeuraAjoute.numCollab = this.numCollabSelected;
    this.vendeuraAjoute.nom = this.libelleselected;
    this.vendeuraAjoute.prenom = this.prenomSelected;
    this.vendeuraAjoute.telgsm = this.telephoneSelected;
    this.vendeuraAjoute.actif = this.entiteForm.value.actif;
    this.vendeuraAjoute.web = '1';
    this.vendeuraAjoute.mail = this.emailSelected;
    this.vendeuraAjoute.numEntite = this.selectedEntite.numEntite;
    this.vendeuraAjoute.user = "";
    this.vendeuraAjoute.profil = this.selectedProfilo?.a1CODE!;
    this.vendeuraAjoute.titre = this.selectedProfilo.a1CODE;

    this.collabservice.updateCollab(this.vendeuraAjoute).subscribe(
      {
        next: (data: any) => {
          if (data != null) {
            this.share.showprogressbar = false;
            this.messageService.add({ severity: 'success', detail: `${data.nom} ${data.prenom} a été modifié avec succés` });
            this.collabservice.getcollab();
            this.share.isForModifvendeur = false;
          }
          else {
            this.share.showprogressbar = false;
            this.messageService.add({ severity: 'error', detail: `Erreur ` + ` ${data}` });
          }
          this.router.navigate([`/page-vendeurs`])

        },
        error: (err) => {
          this.messageService.add({ severity: 'error', detail: `Erreur ` + ` ${err.error.message}` });
          this.router.navigate([`/page-vendeurs`])
        },
        complete: () => {
          this.share.sendRefrechVendeurs(true);
        }

      }
    )

  }
}